import { Button, Flex, Spinner, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { mixpanelTrackButton } from "../../utils/mixpanelFunctions";
import { StepOneTable } from "./StepOneTable";
import { getBinStatusDataApi, updateBinStatusDataApi } from "./stepOneServices";

const StepOne = ({ dataReadyArray }) => {
  const toast = useToast();
  const columnSequence = [
    "BIN",
    "STATUS",
    "LOT NUMBER",
    "CATEGORY",
    "AVAILABLE QTY.",
    "MINIMUM",
    "MAXIMUM",
  ];
  const [enableEdit, setEnableEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [binStatusData, setBinStatusData] = useState(null);
  //   const binState = state?.app?.binStatus?.data || null;

  const extractValuesForKey = (key) => {
    return dataReadyArray.map((obj) => obj[key]);
  };

  const valuesForLot = extractValuesForKey("lotno");

  const getData = () => {
    getBinStatusDataApi(setLoading)
      .then((res) => {
        console.log(res);
        if (res?.status === "error") {
          toast.closeAll();
          const errors = res?.errors?.split(",");
          errors.forEach((error) => {
            toast({
              title: error.trim(),
              status: "error",
              isClosable: true,
              duration: null,
            });
          });
          setBinStatusData((prev) => res.data);
        } else {
          setBinStatusData((prev) => res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBinStatus = async () => {
    console.log(binStatusData);
    updateBinStatusDataApi(binStatusData)
      .then((res) => {
        console.log(res);
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClick = () => {
    setEnableEdit((prev) => !prev);
    if (enableEdit) {
      handleBinStatus();
    }
    mixpanelTrackButton("home", enableEdit ? "SAVE" : "ENABLE EDITING"); // track button
  };
  //   to load data on initial mount
  useEffect(() => {
    // getBinStatusDataApi(setLoading)
    //   .then((res) => {
    //     console.log(res);
    //     if (res?.status === "error") {
    //       toast.closeAll();
    //       const errors = res?.errors?.split(",");
    //       errors.forEach((error) => {
    //         toast({
    //           title: error.trim(),
    //           status: "error",
    //           isClosable: true,
    //           duration: 5000,
    //         });
    //       });
    //       setBinStatusData((prev) => res.data);
    //     } else {
    //       setBinStatusData((prev) => res.data);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    getData();
  }, []);
  return (
    <>
      {loading ? (
        <div className="flex w-full h-[55vh] items-center justify-center">
          <Spinner size={"xl"} />
        </div>
      ) : (
        <div className="flex flex-col gap-3 w-full mb-1">
          <h2 className="text-[#605D64] text-[18px] font-medium self-start">
            BIN Status
          </h2>
          <Flex w="98%" direction="column" justify="right">
            {binStatusData && (
              <Button
                p="0"
                colorScheme="blue"
                w="150px"
                type="submit"
                onClick={handleClick}
                fontSize="12px"
              >
                {enableEdit ? "SAVE" : "ENABLE EDITING"}
              </Button>
            )}
          </Flex>
          <div>
            {binStatusData && (
              <StepOneTable
                height={"55vh"}
                binStatusData={binStatusData}
                setBinStatusData={setBinStatusData}
                headers={columnSequence}
                valuesForLot={valuesForLot}
                dataReadyArray={dataReadyArray}
                enableEdit={enableEdit}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default StepOne;
